const MIME_BY_EXT = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    svg: 'image/svg+xml',
};

const ALLOWED_MIME = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml']);

export function isRemoteImageUrl(value) {
    return typeof value === 'string' && /^https?:\/\//i.test(value) && !value.includes('base64');
}

function mimeFromUrl(url) {
    try {
        const pathname = new URL(url).pathname;
        const ext = (pathname.split('.').pop() || '').toLowerCase();
        return MIME_BY_EXT[ext] || '';
    } catch {
        return '';
    }
}

function blobToDataUri(blob, mime) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;
            if (typeof result !== 'string') {
                reject(new Error('Failed to read image'));
                return;
            }
            if (mime && result.startsWith('data:')) {
                resolve(result.replace(/^data:[^;]+/, `data:${mime}`));
                return;
            }
            resolve(result);
        };
        reader.onerror = () => reject(reader.error || new Error('Failed to read image'));
        reader.readAsDataURL(blob);
    });
}

export async function remoteImageToDataUri(url) {
    const response = await fetch(url, { mode: 'cors', credentials: 'omit' });
    if (!response.ok) {
        throw new Error('Failed to download image');
    }

    const blob = await response.blob();
    let mime = blob.type;
    if (!mime || mime === 'application/octet-stream' || !ALLOWED_MIME.has(mime)) {
        mime = mimeFromUrl(url) || mime;
    }
    if (!ALLOWED_MIME.has(mime)) {
        throw new Error('Image type is not supported');
    }

    return blobToDataUri(blob, mime);
}

export async function resolveImageForCreate(value) {
    if (!isRemoteImageUrl(value)) {
        return value;
    }
    try {
        return await remoteImageToDataUri(value);
    } catch {
        // CORS or network failure — keep the URL so the API can copy the file.
        return value;
    }
}
